// src/Redux/Slices/AppSlices.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Host from "../../Host/Host";

// ==============================
// HERO
// ==============================

export const getHero = createAsyncThunk("app/getHero", async () => {
  const res = await fetch(`${Host}/api/hero?populate=*`);

  return res.json();
});

// ==============================
// HOME PAGE
// ==============================

export const getHomePage = createAsyncThunk("app/getHomePage", async () => {
  const res = await fetch(`${Host}/api/home-page?populate=*`);

  return res.json();
});

// ==============================
// ABOUT PAGE
// ==============================

export const getAboutPage = createAsyncThunk("app/getAboutPage", async () => {
  const res = await fetch(
    `${Host}/api/about-page?populate[aboutIntro][populate]=image&populate[discourse][populate]=*&populate[missionVision][populate]=*&populate[facilities][populate]=*`,
  );
  return res.json();
});

// ==============================
// ADMISSIONS PAGE
// ==============================

export const getAdmissionsPage = createAsyncThunk(
  "app/getAdmissionsPage",
  async () => {
    const res = await fetch(`${Host}/api/admissions-page?populate=*`);

    return res.json();
  },
);

// ==============================
// PROGRAMS PAGE
// ==============================

export const getProgramsPage = createAsyncThunk(
  "app/getProgramsPage",
  async () => {
    const res = await fetch(
      `${Host}/api/programs-page?populate[programs][populate]=*`,
    );

    return res.json();
  },
);

// ==============================
// CONTACT PAGE
// ==============================

export const getContactPage = createAsyncThunk(
  "app/getContactPage",
  async () => {
    const res = await fetch(`${Host}/api/contact-page?populate=*`);

    return res.json();
  },
);

// ==============================
// FOOTER
// ==============================

export const getFooter = createAsyncThunk("app/getFooter", async () => {
  const res = await fetch(`${Host}/api/footer?populate=*`);
  return res.json();
});

// ==============================
// SOCIAL MEDIA
// ==============================

export const getSocialMedia = createAsyncThunk(
  "app/getSocialMedia",
  async () => {
    const res = await fetch(`${Host}/api/social-media?populate=*`);

    return res.json();
  },
);

// ==============================
// GALLERY
// ==============================

export const getGallery = createAsyncThunk("app/getGallery", async () => {
  const res = await fetch(`${Host}/api/gallery-categories?populate=*`);

  return res.json();
});

// ==============================
// CONTACT LEADS
// ==============================

export const getContactLeads = createAsyncThunk(
  "app/getContactLeads",
  async () => {
    const res = await fetch(`${Host}/api/contact-leads?populate=*`);

    return res.json();
  },
);

// ==============================
// SLICE
// ==============================

const AppSlices = createSlice({
  name: "app",

  initialState: {
    hero: null,
    homePage: null,
    aboutPage: null,
    admissionsPage: null,
    programsPage: null,
    contactPage: null,
    footer: null,
    socialMedia: null,

    gallery: [],
    contactLeads: [],

    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // HERO
      .addCase(getHero.fulfilled, (state, action) => {
        state.hero = action.payload.data;
      })

      // HOME PAGE
      .addCase(getHomePage.fulfilled, (state, action) => {
        state.homePage = action.payload.data;
      })

      // ABOUT PAGE
      .addCase(getAboutPage.fulfilled, (state, action) => {
        state.aboutPage = action.payload.data;
      })

      // ADMISSIONS PAGE
      .addCase(getAdmissionsPage.fulfilled, (state, action) => {
        state.admissionsPage = action.payload.data;
      })

      // PROGRAMS PAGE
      .addCase(getProgramsPage.fulfilled, (state, action) => {
        state.programsPage = action.payload.data;
      })

      // CONTACT PAGE
      .addCase(getContactPage.fulfilled, (state, action) => {
        state.contactPage = action.payload.data;
      })

      // FOOTER
      .addCase(getFooter.fulfilled, (state, action) => {
        state.footer = action.payload.data;
      })

      // SOCIAL MEDIA
      .addCase(getSocialMedia.fulfilled, (state, action) => {
        state.socialMedia = action.payload.data;
      })

      // GALLERY
      .addCase(getGallery.fulfilled, (state, action) => {
        state.gallery = action.payload.data;
      })

      // CONTACT LEADS
      .addCase(getContactLeads.fulfilled, (state, action) => {
        state.contactLeads = action.payload.data;
      })

      // ==============================
      // GLOBAL LOADING
      // ==============================

      .addMatcher(
        (action) => action.type.endsWith("/pending"),

        (state) => {
          state.loading = true;
        },
      )

      .addMatcher(
        (action) => action.type.endsWith("/fulfilled"),

        (state) => {
          state.loading = false;
        },
      )

      .addMatcher(
        (action) => action.type.endsWith("/rejected"),

        (state, action) => {
          state.loading = false;

          state.error = action.error.message;
        },
      );
  },
});

export default AppSlices.reducer;
